import styled from "styled-components";
import TextField from '@shared/ui/atoms/TextField';
import Colours from '@shared/ui/atoms/Colours';
import { Row } from '@shared/ui/atoms/StructuralLayout';
import { tablet } from '@shared/ui/atoms/MediaQueries';

export const SpaceBetweenRow = styled(Row)`
  justify-content: space-between;
  margin-bottom: 12px;
`

export const ConfigurationSection = styled.div`
  border-bottom: 1px solid ${Colours.mildGrey};
  position: relative;
  margin: 0 0 24px 0;
  padding-bottom: 24px;
  &:last-child {
    border-bottom: none;
  }
`

const ConfigurationOptions = styled.div`
  opacity: .5;
`

const ConfigurationIcon = styled.img`
  height: 24px;
`

export const ConfigurationList = styled.ul`
  list-style-position: inside;
  margin: 8px 0 16px -36px;
  @media (${tablet}) {
    margin: 8px 0 16px 0;
  }
`

export const DeskAvailabilityCount = styled(TextField)`
  input {
    width: 100px;
    text-align: center;
  }
  p {
    display: flex;
    align-items: center;
  }
`
